/**
 * Reference file resolver
 *
 * This class is used to resolve the file from the path
 *
 * It's responsibility is similar to a file system
 */
export class ReferenceFileResolver {
    /**
     * File list that can be resolved
     */
    files;
    _fileMap = new Map();
    /**
     * Create a reference file resolver
     *
     * File root id can be root url, and becomes id for formats where texture is included in binary files, such as BPMX
     * @param files File list
     * @param rootUrl Root url
     * @param fileRootId File root id
     * @returns
     */
    constructor(files, rootUrl, fileRootId) {
        rootUrl = this._pathNormalize(rootUrl);
        this.files = files;
        if (files.length === 0)
            return;
        if (files[0] instanceof File) {
            for (const file of files) {
                const fileRelativePath = this._pathNormalize(file.webkitRelativePath);
                if (!fileRelativePath.startsWith(rootUrl))
                    continue;
                const relativePath = fileRootId + fileRelativePath.slice(rootUrl.length);
                this._fileMap.set(this._pathNormalize(relativePath), file);
            }
        }
        else {
            for (const file of files) {
                const relativePath = fileRootId + file.relativePath;
                this._fileMap.set(this._pathNormalize(relativePath), file);
            }
        }
    }
    /**
     * Resolve the file from the path
     * @param path Path
     * @returns File
     */
    resolve(path) {
        const finalPath = this._pathNormalize(path);
        return this._fileMap.get(finalPath);
    }
    /**
     * Normalize the path
     * @param path Path
     * @returns Normalized path
     */
    _pathNormalize(path) {
        return path.replace(/\\/g, "/").toUpperCase();
    }
}
